import { HeroUIProvider } from "@heroui/react"
import { RouterProvider } from '@tanstack/react-router'
import router from '../router'

export default function App() {
  return (
    <HeroUIProvider navigate={to => router.navigate({ to })}>
      <RouterProvider router={router} />
    </HeroUIProvider>
  )
}
